<template>
    <shield-modal
        id="wistia-modal"
        :hideHeaderClose="true"
        @handleCancel="()=>{$bvModal.hide('wistia-modal')}"
        @handleSubmit="()=>{$bvModal.hide('wistia-modal')}"
        :title="title"
        :hideCancel="true"
        title-tag="h2"
        :size="'md'"
        :enableSubmit="true">
        <template #title>
        <div class="d-flex justify-content-between align-items-center">
            {{ title }}
        </div>
        </template> 
        <template #default>
            <div
                class="position-relative"
                style="padding-bottom: 56.25%"
            >
                <iframe
                    class="wistia-embed position-absolute h-100 w-100"
                    :src="iframeSrc"
                    title="Wistia video player"
                    allowtransparency="true"
                    frameborder="0"
                    scrolling="no"
                    name="wistia-embed"
                    allowfullscreen
                    mozallowfullscreen
                    webkitallowfullscreen
                    oallowfullscreen
                    msallowfullscreen
                />
            </div>
        </template>
        <template #submit-btn>
                Got it!
        </template>
    </shield-modal>
</template>

<script>
import ShieldModal from '../ShieldModal/ShieldModal';
export default {
    name: 'WistiaModal',
    components:{
        ShieldModal
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        videoId: {
            type: String,
            required: true,
        },
    },
    computed: {
        iframeSrc() {
            return `https://fast.wistia.net/embed/iframe/${this.videoId}`;
        },
    },
}
</script>